import Image from 'next/image';
import styled from '@emotion/styled';
import code from '/public/service_qrcode.png';
import { Modal } from '../global/modal';
import { useI18n } from '@/hooks/use-i18n';

interface ContactUsProps {
  title: string;
  open: boolean;
  greeting?: string;
  content: string | React.ReactNode;
  qrCodeSrc?: string;
  onCancel?: () => void;
}

export function ContactUs({
  title,
  open,
  greeting,
  content,
  qrCodeSrc = code.src,
  onCancel,
}: ContactUsProps) {
  const { t } = useI18n('common');
  const defaultGreeting = greeting || t('contact.greeting');
  return (
    <ContactUsModal
      closeButtonYOffset={-28}
      footer={<></>}
      width={400}
      height={'fit-content'}
      headerHeight={72}
      open={open}
      title={title}
      onCancel={onCancel}
    >
      <div className="pt-[24px] px-[36px] pb-0 flex flex-col items-center">
        <div className="text-[14px] font-[500] text-[#000000bf]">
          {defaultGreeting}
          {defaultGreeting && (
            <>
              ： <br />
            </>
          )}
          {content}
        </div>
        <Image
          className="w-[240px] h-[240px] object-contain mt-[24px]"
          src={qrCodeSrc}
          alt={t('contact.qrCodeAlt')}
          width={200}
          height={200}
        />
      </div>
    </ContactUsModal>
  );
}

const ContactUsModal = styled(Modal)`
  .ant-modal-root,
  .ant-modal-wrap {
    z-index: 999999 !important;
  }

  .ant-modal-content {
    overflow: hidden;
    z-index: 999999;

    .ant-modal-close {
      .ant-modal-close-x {
        color: #eeeeee;

        &:hover {
          color: #fff;
        }
      }
    }

    .ant-modal-header {
      background-color: var(--dm-color-primary);
      border-radius: 0;

      .ant-modal-title {
        color: #fff;
      }
    }
  }
`;
